module.exports = __webpack_public_path__ + "montserrat-bold-webfont.58da7171ecffb9808e10.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-bold-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-bold-webfont.woff
// module chunks = styles